<template>
  <div class="w-full flex flex-col">
    <div class="mb-2.5">
      <p class="text-sm text-[#58595b] mb-2.5 text-center">Mass flow rate to Volumetric flow rate for air</p>
      <div class="font-bold text-center">Fill in one value to calculate the other two</div>
    </div>
    <div class="w-full flex flex-col gap-1">
      <div class="input-block w-full flex flex-col gap-0.5">
        <div class="w-full text-sm text-gray">kg/h</div>
        <label
          :for="`${calcType}-${CalculatorFieldsTypes.kg}-input`"
          class="w-full">
          <input
            type="number"
            :id="`${calcType}-${CalculatorFieldsTypes.kg}-input`"
            :title="`${calcType}-${CalculatorFieldsTypes.kg}-input`"
            placeholder=""
            class="w-full h-8 border border-black text-sm text-gray py-2 px-4 rounded-full"
            :class="{ 'border-blue-600 bg-yellow-100': state.inputFields.includes(CalculatorFieldsTypes.kg) }"
            v-model="state.kg"
            @input="updateInputFields(CalculatorFieldsTypes.kg)" />
        </label>
      </div>
      <div class="input-block w-full flex flex-col gap-0.5">
        <div class="w-full text-sm text-gray">lbs/min</div>
        <label
          :for="`${calcType}-${CalculatorFieldsTypes.lbs}-input`"
          class="w-full">
          <input
            type="number"
            :id="`${calcType}-${CalculatorFieldsTypes.lbs}-input`"
            :title="`${calcType}-${CalculatorFieldsTypes.lbs}-input`"
            placeholder=""
            class="w-full h-8 border border-black text-sm text-gray py-2 px-4 rounded-full"
            :class="{ 'border-blue-600 bg-yellow-100': state.inputFields.includes(CalculatorFieldsTypes.lbs) }"
            v-model="state.lbs"
            @input="updateInputFields(CalculatorFieldsTypes.lbs)" />
        </label>
      </div>
      <div class="input-block w-full flex flex-col gap-0.5">
        <div class="w-full text-sm text-gray">SCFM</div>
        <label
          :for="`${calcType}-${CalculatorFieldsTypes.scmf}-input`"
          class="w-full pointer-events-none">
          <input
            type="number"
            :id="`${calcType}-${CalculatorFieldsTypes.scmf}-input`"
            :title="`${calcType}-${CalculatorFieldsTypes.scmf}-input`"
            placeholder=""
            class="w-full h-8 border border-slate-300 text-sm text-gray py-2 px-4 rounded-full"
            :class="{ 'border-blue-600 bg-yellow-100': state.inputFields.includes(CalculatorFieldsTypes.scmf) }"
            v-model="state.scmf" />
        </label>
      </div>
      <div class="w-full flex items-center justify-center px-4 gap-2.5 mt-1">
        <div
          class="text-sm py-1.5 px-3 rounded text-white bg-red hover:bg-dark-red cursor-pointer flex items-center justify-center transition-colors duration-300"
          :class="{ 'grayscale pointer-events-none': !(Boolean(state.acfm) || Boolean(state.pact) || Boolean(state.tact)) }"
          @click="resetAction">
          Reset
        </div>
        <div
          class="w-full max-w-44 text-sm py-1.5 px-3 rounded text-white bg-red hover:bg-dark-red cursor-pointer flex items-center justify-center transition-colors duration-300"
          :class="{ 'grayscale pointer-events-none': !state.isFormValid }"
          @click="calculateAction">
          Calculate
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, watch } from 'vue';
import GlobalHelper from '@/helpers/global/global.helper';

enum CalculatorFieldsTypes {
  kg = 'acfm',
  lbs = 'pact',
  scmf = 'scmf',
}

const calcType: string = 'mass-flow-to-volumetric-flow-calculator';

const state = reactive({
  kg: '' as string | number,
  lbs: '' as string | number,
  scmf: '' as string | number,
  isFormValid: false as boolean,
  inputFields: [] as string[],
});

const updateInputFields = (field: CalculatorFieldsTypes) => {
  state.inputFields = [];
  state.inputFields.push(field);
};

const checkIsFormValid = () => {
  state.isFormValid = Boolean(state.kg) || Boolean(state.lbs);
};

const resetAction = () => {
  state.kg = '';
  state.lbs = '';
  state.scmf = '';
};

const calculateAction = () => {
  if (state.isFormValid) {
    if (state.lbs !== '') {
      state.kg = GlobalHelper.roundToDecimals(Number(state.lbs) * 27.2155, 4);
    }

    if (state.lbs === '' && state.kg !== '') {
      state.lbs = GlobalHelper.roundToDecimals(Number(state.kg) / 27.2155, 4);
    }

    state.scmf = GlobalHelper.roundToDecimals(Number(state.lbs) / 0.0752, 4);
  }
};

watch(
  () => state.kg,
  () => {
    checkIsFormValid();
  }
);

watch(
  () => state.lbs,
  () => {
    checkIsFormValid();
  }
);
</script>
